import { useQuery } from '@tanstack/react-query';
import Task from '../types/Task';
import Workspace from '../types/Workspace';
import { getSprint, getWorkspaceById } from '../api/workspace';
import { AxiosResponse } from 'axios';
import { useGetActualSpaceId, useGetWorkspace } from './workspace';
import { QUERY_CONFIG } from '../constants/queryConfig';

export const useGetActiveSprintByWorkspace = (space: Workspace | undefined) => {
  const activeSprintId = space?.activeSprintId;
  return useQuery<{ sprint: any }, Error>({
    queryKey: ['sprint', activeSprintId],
    queryFn: async () => {
      const res = await getSprint(space?.id as number, activeSprintId as number);
      return res.data;
    },
    enabled: !!(space?.id && activeSprintId),
    staleTime: QUERY_CONFIG.STALE_TIME,
  });
};

export const getCurrentWorkspaceActiveSprint = () => {
  const workspaceQuery = useGetWorkspace();

  const activeSprintQuery = useGetActiveSprintByWorkspace(workspaceQuery.data);

  return activeSprintQuery;
};

// useWorkspace
export const useWorkspace = (spaceId: number) => {
  return useQuery<Workspace, Error>({
    queryKey: ['workspace', spaceId],
    queryFn: async () => {
      const res = await getWorkspaceById(spaceId);
      return res.data;
    },
    enabled: !!spaceId,
  });
};
